import React from 'react';
import * as LucideIcons from 'lucide-react';

/**
 * Icon component using lucide-react.
 * @param {string} name - PascalCase icon name (e.g., 'MapPin', 'Calendar', 'Users')
 * @param {number} size - Icon size in pixels
 * @param {string} className - Additional CSS classes
 * @param {string} color - Icon color
 * @param {number} strokeWidth - Stroke width
 */
const Icon = ({ name, size = 20, className = '', color, strokeWidth = 2, style = {} }) => {
  const LucideIcon = LucideIcons[name];

  if (!LucideIcon) {
    return <span className={className} style={{ width: size, height: size, display: 'inline-flex', ...style }}></span>;
  }

  return (
    <LucideIcon
      size={size}
      className={className}
      color={color}
      strokeWidth={strokeWidth}
      style={style}
    />
  );
};

export default Icon;
